"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var ContactAction;
(function (ContactAction) {
    ContactAction.ON_CONTACT_FORM_CLICKED = 'ON_CONTACT_FORM_CLICKED';
    ContactAction.ON_CONTACT_FORM_SET_ON_LOADED = 'ON_CONTACT_FORM_SET_ON_LOADED';
    ContactAction.onContactFormClicked = typesafe_actions_1.createAction(ContactAction.ON_CONTACT_FORM_CLICKED, function (resolve) { return function () { return resolve(); }; });
    ContactAction.setOnLoaded = typesafe_actions_1.createAction(ContactAction.ON_CONTACT_FORM_SET_ON_LOADED, function (resolve) { return function (isLoaded) { return resolve(isLoaded); }; });
})(ContactAction || (ContactAction = {}));
exports.default = ContactAction;
